import React from "react";
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Layout,
  Menu,
  Modal,
  Row,
  theme,
} from "antd";
import { connect } from "react-redux";
import { userActions } from "../../_actions";
import "./home.css";
import { Carousel } from "antd";
import { slide1_1, slide1_2, slide1_3, bg1_1 } from "./sliders/slider";
import {
  UserOutlined,
  LockOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  CodeSandboxOutlined,
  MailOutlined,
} from "@ant-design/icons";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import ReCAPTCHA from "react-google-recaptcha";
import "./../../responsive.css";
import axios from "axios";
import { Content, Footer, Header } from "antd/lib/layout/layout";
import {
  Media1,
  Media2,
  Media3,
  Media4,
  Media5,
  Media6,
  Media7,
  Media8,
  Media9,
  Media10,
} from "../../_assets/media";
import {
  Coverage1,
  Coverage2,
  Coverage3,
  Coverage4,
} from "../../_assets/coverage";
import { LoginPage } from "./LoginPage";
import { LanguageContext } from "../../context/LanguageContext";

const TEST_SITE_KEY = process.env.REACT_APP_SITE_KEY;
const DELAY = 1500;

const contentStyle = {
  height: "80vh",
  color: "#fff",
  lineHeight: "100vh",
  textAlign: "center",
  background: "#364967",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};
class MainPage extends React.Component {
  static contextType = LanguageContext;

  constructor(props) {
    super(props);
    // reset login status
    this.state = {
      activeKey: "2",
      isModalVisible: false,
    };
  }

  handleChange = (e) => {
    this.context.setLanguage(e);
  };

  handleMenuClick = (e) => {
    console.log("e", e);
    if (e.key === "3") {
      this.setState({ isModalVisible: true });
    } else {
      this.setState({ activeKey: e.key });
    }
  };

  handleModalClose = () => {
    this.setState({ isModalVisible: false });
  };

  render() {
    const { language, t } = this.context;

    console.log("LANGUAGE===>", language, t);

    console.log(t("cmis"));

    const { activeKey } = this.state;
    console.log("activeKey", activeKey);
    const items = [
      { key: "1", label: "Media" },
      { key: "2", label: "Coverage" },
      { key: "3", label: "Login" },
    ];

    return (
      <>
        <div style={{ minHeight: "100vh" }}>
          <Layout
            style={{
              minHeight: "100vh",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Header
              style={{
                display: "flex",
                alignItems: "center",
              }}
              className="home-header"
            >
              <h1 className="logo">
                <a href="/login" style={{color:'white'}}>CMIS</a>
              </h1>
              {/* <div
                style={{
                  justifyContent: "center",
                  flex: 1,
                  minWidth: 0,
                  background: "#384e75",
                }}
              >
                <Button
                  onClick={() => {
                    this.handleChange("en");
                  }}
                >
                  English
                </Button>
                <Button
                  onClick={() => {
                    this.handleChange("mr");
                  }}
                >
                  Marathi
                </Button>
              </div> */}
              <Menu
                theme="dark"
                mode="horizontal"
                defaultSelectedKeys={[activeKey]}
                items={items}
                style={{
                  justifyContent: "end",
                  flex: 1,
                  minWidth: 0,
                  background: "#384e75",
                }}
                onClick={(e) => this.handleMenuClick(e)}
              />
            </Header>
            <Content className="contentLayout" style={{ flex: 1 }}>
              {activeKey == "1" && (
                <>
                  <div
                    className="crousel"
                    style={{ marginTop: "50px", textAlign: "center" }}
                  >
                    <Carousel effect="fade" autoplay>
                      <div>
                        <img src={Media1} className="media-img" />
                      </div>
                      <div>
                        <img src={Media2} className="media-img" />
                      </div>
                      <div>
                        <img src={Media3} className="media-img" />
                      </div>
                      <div>
                        <img src={Media4} className="media-img" />
                      </div>
                      <div>
                        <img src={Media5} className="media-img" />
                      </div>
                      <div>
                        <img src={Media6} className="media-img" />
                      </div>
                      <div>
                        <img src={Media7} className="media-img" />
                      </div>
                      <div>
                        <img src={Media8} className="media-img" />
                      </div>
                      <div>
                        <img src={Media9} className="media-img" />
                      </div>
                      <div>
                        <img src={Media10} className="media-img" />
                      </div>
                    </Carousel>
                  </div>
                </>
              )}
              {activeKey == "2" && (
                <>
                  <div
                    className="crousel"
                    style={{ marginTop: "50px", textAlign: "center" }}
                  >
                    <Carousel effect="fade" autoplay>
                      <div>
                        <img src={Coverage1} className="media-img" />
                      </div>
                      <div>
                        <img src={Coverage2} className="media-img" />
                      </div>
                      <div>
                        <img src={Coverage3} className="media-img" />
                      </div>
                      <div>
                        <img src={Coverage4} className="media-img" />
                      </div>
                    </Carousel>
                  </div>
                </>
              )}
              {activeKey == "6" && (
                <>
                  <div style={{ marginTop: "50px" }}>
                    <h2 style={{ marginBottom: "20px", textAlign: "center" }}>
                      {" "}
                      Contact Us
                    </h2>
                    <div
                      style={{
                        textAlign: "center",
                        width: "80%",
                        margin: "auto",
                      }}
                    >
                      <Card>
                        <h3>I MARK TECHNOLOGY</h3>
                        <div style={{ marginTop: 16 }}>
                          <p
                            style={{
                              fontSize: "16px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <EnvironmentOutlined
                              style={{ marginRight: "8px" }}
                            />
                            301, Vijayraj Marvel, Prem Nagar, Jule Solapur
                          </p>
                          <p
                            style={{
                              fontSize: "16px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <CodeSandboxOutlined
                              style={{ marginRight: "8px" }}
                            />
                            Solapur-413004
                          </p>
                          <p
                            style={{
                              fontSize: "16px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <MailOutlined style={{ marginRight: "8px" }} />

                            <a href="mailto:imarktechnology1@gmail.com">
                              imarktechnology1@gmail.com
                            </a>
                          </p>
                        </div>
                      </Card>
                    </div>
                  </div>
                </>
              )}
              {activeKey == "4" && (
                <div style={{ marginTop: "50px" }}>
                  <h2 style={{ marginBottom: "20px", textAlign: "center" }}>
                    {" "}
                    Disclaimer
                  </h2>
                  <Row style={{ width: "80%", margin: "auto" }}>
                    <Col>
                      <Card>
                        <p>
                          <b>General Disclaimer</b>
                        </p>
                        <span>
                          CMIS is a secure, internal-use platform created
                          exclusively for use by the Police Department. It is
                          designed to maintain and analyze criminal records.
                          While every effort is made to ensure data accuracy,
                          CMIS does <b>not guarantee</b> that the information is
                          error-free or exhaustive.
                        </span>
                        <p>
                          <b>Limited Liability</b>
                        </p>
                        <span>
                          I MARK TECHNOLOGY and associated departments shall not
                          be held liable for:
                        </span>
                        <span>
                          <ul>
                            <li>
                              Any unauthorized access or misuse of data by users
                            </li>
                            <li>
                              Any legal or procedural action taken based solely
                              on CMIS data
                            </li>
                            <li>
                              Delays or system errors beyond reasonable control
                            </li>
                          </ul>
                        </span>
                        <p>
                          <b>Usage Responsibility</b>
                        </p>
                        <span>
                          <ul>
                            <li>
                              All users must ensure that the data they enter is
                              accurate and legally obtained
                            </li>
                            <li>
                              CMIS is to be used only for lawful purposes by
                              police personnel. Misuse or manipulation of the
                              system may result in disciplinary or legal action.
                            </li>
                          </ul>
                        </span>
                      </Card>
                    </Col>
                  </Row>
                </div>
              )}
              {activeKey == "5" && (
                <>
                  <div style={{ marginTop: "50px" }}>
                    <h2 style={{ marginBottom: "20px", textAlign: "center" }}>
                      {" "}
                      Privacy Policy
                    </h2>
                    <Row style={{ width: "80%", margin: "auto" }}>
                      <Col>
                        <Card>
                          <p>
                            <b>Introduction</b>
                          </p>
                          <span>
                            This Privacy Policy outlines how CMIS, developed and
                            maintained by <b>I MARK TECHNOLOGY</b>, collects,
                            stores, and uses information entered into the system
                            by authorized users from police departments.
                          </span>
                          <p>
                            <b>Data Collection</b>
                          </p>
                          <span>
                            CMIS may collect and store the following
                            information:
                          </span>
                          <span>
                            <ul>
                              <li>
                                Criminal records including name, address, mobile
                                number, caste, FIR details, photographs, etc.
                              </li>
                              <li>
                                User credentials (Police Station ID, Unit Admin
                                ID, etc.)
                              </li>
                              <li>
                                Information related to patrolling,
                                investigation, and crime history
                              </li>
                              <li>Access logs and activity records of users</li>
                            </ul>
                          </span>
                          <p>
                            <b>Purpose of Data Usage</b>
                          </p>
                          <span>
                            The data is collected and stored for the following
                            purposes:
                          </span>
                          <span>
                            <ul>
                              <li>Maintaining accurate criminal records</li>
                              <li>
                                Enabling police officials to take preventive and
                                legal action
                              </li>
                              <li>
                                Supporting data-based analysis and reports for
                                crime reduction
                              </li>
                              <li>
                                Ensuring accountability and operational
                                transparency
                              </li>
                            </ul>
                          </span>
                          <p>
                            <b>Data Access and Protection</b>
                          </p>
                          <span>
                            <ul>
                              <li>
                                Data is accessible only to{" "}
                                <b>authorized personnel</b>
                                based on roles (Super User, Unit Admin, Police
                                Station User)
                              </li>
                              <li>
                                All sensitive information is protected through
                                secure storage and access controls
                              </li>
                              <li>Regular backups are maintained</li>
                            </ul>
                          </span>
                          <p>
                            <b>Data Sharing</b>
                          </p>
                          <span>
                            <ul>
                              <li>
                                No data is shared with third parties except when
                                required by legal authority or under the
                                supervision of law enforcement agencies. .
                              </li>
                            </ul>
                          </span>
                          <p>
                            <b>Your Rights</b>
                          </p>
                          <span>
                            <ul>
                              <li>
                                Only authorized users can view or update
                                specific records
                              </li>
                              <li>
                                All data modifications are logged with user ID
                                and timestamp and IP address
                              </li>
                            </ul>
                          </span>
                          <p>
                            <b>Updates to the Policy</b>
                          </p>
                          <span>
                            We may modify this Privacy Policy as needed. Users
                            will be informed through the system interface in
                            case of significant changes.
                          </span>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </>
              )}
            </Content>
            <Footer style={{ textAlign: "center" }}>
              <div className="text-center">
                <div style={{ marginTop: 8 }}>
                  <p style={{ marginTop: 8, fontSize: "14px" }}>
                    <p
                      style={{
                        display: "inline",
                        margin: "0 10px",
                        cursor: "pointer",
                        color: "rgb(56, 78, 117)",
                        fontSize: "16px",
                      }}
                      onClick={() => this.setState({ activeKey: "4" })}
                    >
                      <b>Disclaimer</b>
                    </p>
                    |
                    <p
                      style={{
                        display: "inline",
                        margin: "0 10px",
                        cursor: "pointer",
                        color: "rgb(56, 78, 117)",
                        fontSize: "16px",
                      }}
                      onClick={() => this.setState({ activeKey: "5" })}
                    >
                      <b>Privacy Policy</b>
                    </p>
                    |
                    <p
                      style={{
                        display: "inline",
                        margin: "0 10px",
                        cursor: "pointer",
                        color: "rgb(56, 78, 117)",
                        fontSize: "16px",
                      }}
                      onClick={() => this.setState({ activeKey: "6" })}
                    >
                      <b>Contact Us</b>
                    </p>
                  </p>
                </div>
                <b>
                  {" "}
                  <p>2021-2026 Developed and Managed by I Mark Technology</p>
                </b>
              </div>
            </Footer>
            {/* <Modal
            width="100%"
            title="Login"
            open={this.state.isModalVisible}
            onOk={this.handleModalClose} // Close modal on OK
            onCancel={this.handleModalClose} // Close modal on Cancel
          > */}
            {this.state.isModalVisible && (
              <LoginPage
                isModalVisible={this.state.isModalVisible}
                handleModalClose={this.handleModalClose}
              />
            )}

            {/* </Modal> */}
          </Layout>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {}
const connectedMainPage = connect(mapStateToProps)(MainPage);
export { connectedMainPage as MainPage };
